import { Link } from '@tanstack/react-router';
import { useAuthStore } from '../store/auth.ts';
import { ThemeToggle } from './ThemeToggle.tsx';
import { Icon } from './Icon.tsx';

// Material 3 top app bar (mobile). Logo + wordmark, with the theme toggle and
// sign-out as trailing icon buttons — the navigation bar below is destinations
// only, so those two actions live here.
export function Header(): JSX.Element | null {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  if (!user) return null;
  return (
    <header
      className="md:hidden sticky top-0 z-30 flex h-16 items-center justify-between gap-4 px-3 bg-[hsl(var(--chrome))]"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <Link to="/" className="flex items-center gap-2.5 min-w-0 ml-1">
        <img
          src="/icons/wapoffice-mark.svg"
          alt=""
          className="size-9 shrink-0"
        />
        <span className="text-lg font-medium leading-none text-ink truncate">Wapplify Office</span>
      </Link>
      <div className="flex items-center gap-0.5 shrink-0">
        <ThemeToggle />
        <button
          onClick={logout}
          aria-label="Sign out"
          className="grid size-11 place-items-center rounded-full text-muted-foreground hover:bg-muted/70 transition-colors"
        >
          <Icon name="logout" size={22} />
        </button>
      </div>
    </header>
  );
}
